import { ArrowLeft, VipBadge } from "../svg";
import { PlayerBuyPackageButtonProps } from "./player.buy.package.button.props";
import { FullScreenIcon } from "../svg/svgs/fullScreen";

export const PlayerFullScreen: React.FC<PlayerBuyPackageButtonProps> = ({
  player,
  hasLockStram,
  hasLockSub,
  packageId,
  programId,
}) => {
  //#region dependencies

  //#endregion

  //#region methods

  const onClick = () => {
    player.toggleFullScreen();
  };

  //#endregion

  return (
    <div
      className="d-flex align-items-center full-screen-button rtl selectableItem"
      onClick={onClick}
    >
      <div
        className="full-screen-button__button d-sm-flex align-items-center mr-auto d-none"
        style={{ justifyContent: "center" }}
      >
        <span>تمام صفحه</span>
      </div>
    </div>
  );
};
